import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useLazyQuery } from '@apollo/client'
import { FreshDeskOverview } from './Overview'
import { FreshDeskTable } from './FreshdeskTable'
import { GET_FRESHDESK_TCKETS } from '../../../grapghQl/queries/freshDesk'
import { useSearchParams } from 'react-router-dom'
import _colors from "../../../tailwind/_colors.js"
import { HelmetSEO } from '../../../components/common/index.js'
import { SEO } from '../../../utils/seo.js'

const initialValues = [
    { title: 'Total', count: 0, fill: _colors?.['secondary']?.[400], query: "1", field: "total" },
    { title: 'Open', count: 0, fill: _colors?.['warning']?.[400], query: "2", field: "open" },
    { title: 'Pending', count: 0, fill: _colors?.['warning']?.[400], query: "3", field: "pending" },
    { title: 'On Hold', count: 0, fill: _colors?.['danger']?.[400], query: "8", field: "onhold" },
    { title: 'Resolved', count: 0, fill: _colors?.['teal']?.[400], query: "4", field: "resolved" },
    { title: 'Closed', count: 0, fill: _colors?.['success']?.[400], query: "5", field: "closed" }
]

const GreytHRSupport = () => {
    const [startDate, setStartDate] = useState(new Date());
    let [searchParams, setSearchParams] = useSearchParams();
    const [getFreshDeskTickets] = useLazyQuery(GET_FRESHDESK_TCKETS, { fetchPolicy: 'no-cache' });
    const [pageParams, setParams] = useState({})
    const [filterBy, setFilterBy] = useState("")
    const [allRows, setAllRows] = useState([])

    const [tickets, setTickets] = useState(initialValues)
    const activeURL = searchParams?.get('client_url') || null;
    const activeQuery = searchParams?.get('status') || null;

    const fetchDataFromAPI = async (params) => {
        const filtermodel = params.api.getFilterModel()
        const { date, status, search = {} } = filtermodel || { date: {}, status: {}, search: {} }
        const { filter: dateFilter, } = date || { filter: startDate, }
        const { filter: statusFilter } = status || { statusFilter: activeQuery }
        const { filter: domainFilter } = search || { domainFilter: "" }
       
        params.api.showLoadingOverlay();
        try {
            const { data } = await getFreshDeskTickets({
                variables: {
                    startRow: params.request.startRow,
                    endRow: params.request.endRow,
                    startDate: moment(dateFilter)?.startOf('month')?.format('YYYY-MM-DD'),
                    endDate: moment(dateFilter)?.endOf('month')?.format('YYYY-MM-DD'),
                    requesterId: null,
                    sorting: null,
                    status: Number(statusFilter) === 1 ? null : Number(statusFilter) !== undefined ? Number(statusFilter) : Number(activeQuery) ? Number(activeQuery) : null,
                    clientDomain: domainFilter?.replace('/', '')
                }
            })
            const { greyTHRSupportTickets } = data || { greyTHRSupportTickets: {} }
            const { data: results, total = 0 } = greyTHRSupportTickets || { data: [], total: 0 };
            params?.successCallback(results, total);
            params?.api?.hideOverlay();
            (!results?.length) && params?.api?.showNoRowsOverlay();
            setAllRows(results)

        } catch (error) {
            params?.api?.hideOverlay();
            params.failCallback()
        }
    }

    const datasource = {
        async getRows(params) {
            setParams({ ...params })
            fetchDataFromAPI({ ...params })
        }
    }

    const handleUpdateMonth = (date) => {
        setStartDate(date);
        Object?.keys(pageParams?.api)?.length &&
            pageParams?.api?.setFilterModel({
                date: { filterType: "text", type: "contains", filter: date },
                status: { filterType: "text", type: "contains", filter: activeQuery },
                search: { filterType: "text", type: "contains", filter: '' },
            })
    }

    const handleClickFilter = (item) => {
        const { query } = item;
        setSearchParams({ status: query === "1" ? null : query })
        Object?.keys(pageParams?.api)?.length &&
            pageParams?.api?.setFilterModel({
                status: { filterType: "text", type: "contains", filter: query },
                date: { filterType: "text", type: "contains", filter: startDate },
                search: { filterType: "text", type: "contains", filter: '' },
            })
    }

    const searchByStatus = (value, i) => {
        setSearchParams({ status: value })
        Object?.keys(pageParams?.api)?.length &&
            pageParams?.api?.setFilterModel({ status: { filterType: "text", type: "contains", filter: value } })
    }
    const getRowStyle = (params) => {
        const { data: { haveAccess = false } = {} } = params;
        return haveAccess === false ? { 'display': 'none', height: 0 } : {}
    }

    const getRowHeight = (params) => {
        const { data: { haveAccess = false } = {} } = params;
        return haveAccess ? 64 : 0

    }
 
    const gridOptions = {
        pagination: false,
        groupHideOpenParents: true,
        serverSideFilterOnServer: true,
        serverSideDatasource: datasource,
        rowModelType: "serverSide",
        cacheBlockSize: 30,
        getRowHeight: getRowHeight,
        paginationPageSize: 30,
        cacheOverflowSize: 2,
        maxConcurrentDatasourceRequests: 2,
        infiniteInitialRowCount: 1,
        maxBlocksInCache: 2,
        getRowStyle: getRowStyle
    };

    const onSelectFilterByClient = (props) => {
        const { status = null, url = null  } = props;
       
        const filters = {
            ...(url && { search: { filterType: "text", type: "contains", filter: url } }),
            ...(status && { status: { filterType: "text", type: "contains", filter: status } }),
            ...(startDate && { date: { filterType: "text", type: "contains", filter: startDate } })
        }
 
        Object?.keys(pageParams?.api)?.length && pageParams?.api?.setFilterModel(filters)
        setSearchParams({ status: status });
        setFilterBy(url)
    } 

    useEffect(() => {
        activeURL && onSelectFilterByClient({ url: activeURL })
        //eslint-disable-next-line 
    }, [activeURL])

    return (
        <div>
             <HelmetSEO content={SEO['GREYTHR_SUPPORT']} />
            <FreshDeskOverview allRows={allRows} handleClickFilter={handleClickFilter} setTickets={setTickets} activeQuery={activeQuery}
                startDate={startDate} tickets={tickets} handleUpdateMonth={handleUpdateMonth} pageParams={pageParams} />
            <FreshDeskTable activeQuery={activeQuery} handleClickFilter={handleClickFilter} searchByStatus={searchByStatus} onSelectFilterByClient={onSelectFilterByClient}
                filterBy={filterBy}
                gridOptions={gridOptions} params={pageParams} startDate={startDate} />
        </div>
    )
}

export default React.memo(GreytHRSupport)